
// import designAndGraphics from "../assets/CategoryIcon/graphic-and-design.svg"
// import programming from "../assets/CategoryIcon/programming.svg"
// import digitalMarketing from "../assets/CategoryIcon/digital-marketing.svg"
// import health from "../assets/CategoryIcon/health-care.svg"

// export const JobCategoryData = [
//     {
//         logo: designAndGraphics,
//         name:"Design et Graphisme",
//         offerNumber: 124
//     },
//     {
//         logo: programming,
//         name:"Programmation",
//         offerNumber: 124
//     },
//     {
//         logo: digitalMarketing,
//         name:"Marketing",
//         offerNumber: 124
//     },
//     {
//         logo: health,
//         name:"Santé",
//         offerNumber: 124
//     },
//     {
//         logo: digitalMarketing,
//         name:"Marketing",
//         offerNumber: 124
//     },
//     {
//         logo: digitalMarketing,
//         name:"Marketing",
//         offerNumber: 124
//     },
//     {
//         logo: digitalMarketing,
//         name:"Marketing",
//         offerNumber: 124
//     },
//     {
//         logo: digitalMarketing,
//         name:"Marketing",
//         offerNumber: 124
//     }
// ]

import designAndGraphics from "../assets/CategoryIcon/graphic-and-design.svg"
import programming from "../assets/CategoryIcon/programming.svg"
import digitalMarketing from "../assets/CategoryIcon/digital-marketing.svg"
import health from "../assets/CategoryIcon/health-care.svg"
import finance from "../assets/CategoryIcon/dollar-finance-money-9-svgrepo-com.svg"
import education from "../assets/CategoryIcon/education-learning-5-svgrepo-com.svg"
import engineering from "../assets/CategoryIcon/engineering-helmet-cog-svgrepo-com.svg"
import customerService from "../assets/CategoryIcon/headset-svgrepo-com (1).svg"

export const JobCategoryData = [
    {
        logo: designAndGraphics,
        name: "Design et Graphisme",
        offerNumber: 2
    },
    {
        logo: programming,
        name: "Programmation",
        offerNumber: 1
    },
    {
        logo: digitalMarketing,
        name: "Marketing Digital",
        offerNumber: 2
    },
    {
        logo: health,
        name: "Santé",
        offerNumber: 0
    },
    {
        logo: finance,
        name: "Finance",
        offerNumber: 0
    },
    {
        logo: education,
        name: "Éducation",
        offerNumber: 0
    },
    {
        logo: engineering,
        name: "Ingénierie",
        offerNumber: 1
    },
    {
        logo: customerService,
        name: "Service Client",
        offerNumber: 1
    }
]
